'use client';

import { Button } from '@nextui-org/react';
import Image from 'next/image';

import { EmptyState } from '@/components/ui/empty-state/empty-state';
import { Link } from '@/shared/navigation';
import { ROUTES } from '@/shared/routes/routes';

export const NoPermissions = () => {
  return (
    <EmptyState
      icon={
        <Image
          alt="empty"
          src="/empty/empty-no-permissions.svg"
          width={300}
          height={300}
        />
      }
      title="Недостаточно прав"
      description="Для просмотра страницы обратитесть к администратору"
      bottom={
        <Link href={ROUTES.home}>
          <Button color="primary">На главную</Button>
        </Link>
      }
    />
  );
};
